// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { defaultResource } from "./default";

i18n.use(initReactI18next).init({
  resources: defaultResource,
  lng: "sharedui",
  fallbackLng: "sharedui",
  defaultNS: "translation",
  interpolation: {
    escapeValue: false // react already safes from xss
  }
});

export default i18n;
